import { PayloadAction } from '@reduxjs/toolkit';

import {
  CompId,
  CompTypes,
  RefetchCompsCompTypeSliceState,
  RefetchCompsSliceState,
  ReportId,
} from '@hcs/types';
import { createHcReduxSlice } from '@hcs/utils';

const COMPS_LIMIT = 500;

const INITIAL_COMP_TYPE_STATE: RefetchCompsCompTypeSliceState = {
  reportId: undefined,
  showRecentlyAdded: false,
  isLoading: false,
  recentlyAddedToFarm: [],
  recentlyAddedToFarmFiltered: [],
  latestRefetchReturnedNoNewComps: false,
  limit: COMPS_LIMIT,
};
const initialState: RefetchCompsSliceState = {
  SOLD: {
    ...INITIAL_COMP_TYPE_STATE,
  },
  RENTAL: {
    ...INITIAL_COMP_TYPE_STATE,
  },
};
export const refetchCompsSlice = createHcReduxSlice({
  name: 'refetchComps',
  initialState,
  reducers: {
    resetSliceState(state, action: PayloadAction<{ reportId: ReportId }>) {
      state = {
        SOLD: {
          ...INITIAL_COMP_TYPE_STATE,
          reportId: action.payload.reportId,
        },
        RENTAL: {
          ...INITIAL_COMP_TYPE_STATE,
          reportId: action.payload.reportId,
        },
      };
      return state;
    },
    setIsLoading(
      state,
      action: PayloadAction<{ compType: CompTypes; isLoading: boolean }>,
    ) {
      state[action.payload.compType].isLoading = action.payload.isLoading;
    },
    setRecentlyAddedToFarm(
      state,
      action: PayloadAction<{
        compType: CompTypes;
        recentlyAddedToFarm: CompId[];
      }>,
    ) {
      const { compType, recentlyAddedToFarm } = action.payload;
      state[compType].isLoading = false;
      state[compType].latestRefetchReturnedNoNewComps =
        recentlyAddedToFarm.length === 0;
      state[compType].recentlyAddedToFarm = recentlyAddedToFarm;
      // Reset showRecentlyAdded when no new comps are found to prevent
      // the comps list from showing 0 results when filtered to empty recently added list
      if (recentlyAddedToFarm.length === 0) {
        state[compType].showRecentlyAdded = false;
      }
    },
    setRecentlyAddedToFarmFiltered(
      state,
      action: PayloadAction<{
        compType: CompTypes;
        // Comp IDs from the comps_filtered document
        compIDs: CompId[];
      }>,
    ) {
      const { compType, compIDs } = action.payload;
      state[compType].recentlyAddedToFarmFiltered = state[
        compType
      ].recentlyAddedToFarm.filter((compId) => compIDs.includes(compId));
    },
    setViewRecentlyAddedComps(
      state,
      action: PayloadAction<{ compType: CompTypes; show: boolean }>,
    ) {
      const { compType, show } = action.payload;
      state[compType].showRecentlyAdded = show;
    },
    resetLatestRefetchReturnedNoNewComps(
      state,
      action: PayloadAction<{ compType: CompTypes }>,
    ) {
      const { compType } = action.payload;
      state[compType].latestRefetchReturnedNoNewComps = false;
    },
  },
});
